<template>
  <div class="menu-item-wrapper">
    <!-- 有子菜单的项 -->
    <el-submenu
      v-if="hasChildren"
      :index="menuItem.id + ''"
      :class="['level-' + level]"
    >
      <template slot="title">
        <span class="menu-indent" :style="{width: (level - 1) * 4 + 'px'}"></span>
<!--        <i class="fas expand-icon" :class="isExpanded ? 'fa-caret-down' : 'fa-caret-right'"></i>-->
        <i class="fas menu-icon" :class="getNavIcon(menuItem)"></i>
        <span class="menu-text">{{ menuItem.name }}</span>
      </template>

      <!-- 递归渲染子菜单，层级+1 -->
      <menu-item
        v-for="child in menuItem.children"
        :key="child.id || child.name"
        :menu-item="child"
        :level="level + 1"
      ></menu-item>
    </el-submenu>

    <!-- 无子菜单的项 -->
    <el-menu-item
      v-else
      :index="menuItem.id + ''"
      :class="['level-' + level]"
    >
      <span class="menu-indent" :style="{width: level * 4 + 'px'}"></span>
      <i class="fas menu-icon leaf-icon" :class="getNavIcon(menuItem)"></i>
      <span class="menu-text">{{ menuItem.name }}</span>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    menuItem: {
      type: Object,
      required: true,
      description: '菜单数据项'
    },
    level: {
      type: Number,
      default: 1,
      description: '当前菜单层级，默认为1级'
    }
  },
  computed: {
    hasChildren() {
      return this.menuItem.children && Array.isArray(this.menuItem.children) && this.menuItem.children.length > 0;
    },
    // 获取当前子菜单展开状态
    isExpanded() {
      // 这里需要访问父组件的展开状态
      return this.$parent.$parent.expanded;
    }
  },
  methods: {
    getNavIcon(item) {
      // 为不同层级和类型的菜单设置不同的默认图标
      if (item.icon) {
        return item.icon;
      }
      return this.hasChildren ? 'fa-folder' : 'fa-file-alt';
    }
  }
};
</script>

<style scoped>
.menu-item-wrapper {
  position: relative;
}

/* 层级连接线 */
/*.menu-item-wrapper::before {*/
/*  content: '';*/
/*  position: absolute;*/
/*  left: 16px;*/
/*  top: 0;*/
/*  bottom: 0;*/
/*  width: 1px;*/
/*  background-color: #e4e7ed;*/
/*  z-index: 1;*/
/*}*/

/* 第一级菜单不显示左侧连接线 */
.level-1 .menu-item-wrapper::before {
  display: none;
}

/* 缩进样式 */
.menu-indent {
  display: inline-block;
  vertical-align: middle;
  height: 100%;
}

/* 图标样式 */
.expand-icon {
  width: 16px;
  text-align: center;
  transition: transform 0.3s;
  margin-right: 4px;
}

.menu-icon {
  width: 16px;
  text-align: center;
  margin-right: 8px;
  opacity: 0.8;
}

/* 叶子节点特殊样式 */
.leaf-icon {
  color: #67c23a;
}

/* 菜单文本样式 */
.menu-text {
  vertical-align: middle;
}

/* 不同层级的样式区分 */
.level-1 .menu-text {
  font-weight: bold;
}

.level-2 .menu-text {
  color: #303133;
}

.level-3 .menu-text {
  color: #606266;
}

.level-4 .menu-text {
  color: #909399;
}

/* 鼠标悬停效果 */
.el-menu-item:hover, .el-submenu__title:hover {
  background-color: #f5f7fa !important;
}

/* 选中状态样式 */
.el-menu-item.is-active {
  background-color: #e6f7ff !important;
  color: #1890ff !important;
}

.el-menu-item.is-active .menu-icon {
  color: #1890ff !important;
}
</style>

